import { api } from './client'
import type { ConfiguracionItem, ConfiguracionMarca, ConfiguracionPublica } from '@/types/api'

export const configuracionApi = {
  listar: () => api.get<ConfiguracionItem[]>('/configuracion').then((r) => r.data),
  publica: () => api.get<ConfiguracionPublica>('/configuracion/publica').then((r) => r.data),
  /** Nombre y logo; no requiere sesión (pantalla de login). */
  marca: () => api.get<ConfiguracionMarca>('/configuracion/marca').then((r) => r.data),
  actualizar: (clave: string, valor: unknown) =>
    api.patch<ConfiguracionItem>(`/configuracion/${clave}`, { valor }).then((r) => r.data),
  restablecer: (clave: string) =>
    api.delete<ConfiguracionItem>(`/configuracion/${clave}`).then((r) => r.data),
}
